module.exports = __webpack_public_path__ + "img/rocket.80d29fc1.svg";